import {Location} from "../../../feature/project/Shot";
import React, {Fragment, useEffect, useState} from "react";
import {Starfield} from "../../../components/Starfiled";
import {AnimatableElement} from "./AnimatableElement";


export const LocationElement = (props: {
    editable: boolean,
    prefix: string,
    style?: React.CSSProperties,
    location: Location | undefined,
    play: boolean,
    onMove?: (info: { x: number, y: number, z: number, scale: number }) => void,
    onPlayEnd: (id: number) => void,
    onElementSelected: () => void,
}) => {
    const [played, setPlayed] = useState<Set<number>>(new Set<number>())

    useEffect(() => {
        const total = props.location?.layers?.length || 0
        if (played.size === total && props.play) {
            props.onPlayEnd(props.location?.id || 0)
            setPlayed(new Set())
        }
    }, [played, props.location, props.play])

    return (
        <>
            {
                props.location ?
                    props.location.layers && props.location.layers.length > 0 ?
                            <div id={"location-layers"} style={{width: '100%', height: '100%', position: 'relative'}}>
                                {props.location.layers?.map(layer => {
                                    return props.location?.layers && props.location.layers.length > 0 ?
                                        <AnimatableElement
                                            element={layer}
                                            play={props.play}
                                            key={layer.id}
                                            scale={layer.scale ?? 1}
                                            animations={layer.animations && layer.animations.length > 0 ? layer.animations : [{id: -1}]}
                                            onPlayEnd={(id: number) => {
                                                if (props.play) {
                                                    setPlayed(prev => new Set(prev).add(id))
                                                }
                                            }}
                                        >
                                            <img src={layer.source}
                                                 draggable={false}
                                                 unselectable={'on'}
                                            />
                                        </AnimatableElement>
                                        : ''


                                })}
                            </div>
                        : <Starfield
                            id={"location-starfield"}
                            starCount={5000}
                            starColor={[255, 255, 255]}
                            speedFactor={0.1}
                            scale={1}
                            backgroundColor="black"
                        />
                    : <Starfield
                        id={"location-starfield"}
                        starCount={5000}
                        starColor={[255, 255, 255]}
                        speedFactor={0.1}
                        scale={1}
                        backgroundColor="black"
                    />}
        </>
    )
}